import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class ProductService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  getProductsByMarket(): Observable<boolean> {
    return this.http.get<any>(
      `${this.baseURL}/Product/GetProductsByMarket`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const products = res.body as any;
          return products;
        }),
        catchError(this.handleError)
      );
  }

  getProducts(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Product/GetProducts`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const products = res.body as any;
          return products;
        }),
        catchError(this.handleError)
      );
  }

  saveProduct(newProduct: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/Product/SaveProduct`,
      newProduct,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  deleteProductById(id: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/Product/DeleteProductById/${id}`,
      {}, // empty body, since id is in route
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  GetAllProductCategories(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ProductCategory/GetAllProductCategories`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const categoryDetails = res.body as any;
          return categoryDetails;
        }),
        catchError(this.handleError)
      );
  }

  SaveProductCategories(categoryList: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/ProductCategory/SaveProductCategories`,
      categoryList,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  GetCategoriesSetForProducts(categoryId: number[]): Observable<any[]> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/ProductCategory/GetCategoriesSetForProducts`;
    return this.http.post<any[]>(url, categoryId, options)
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}